import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export const TranslationService = ({opened}) => {
    return (
        <div className={classNames("service-list",{"openlist": opened})}>
            <p className='faq-p'>
                We offer comprehensive immigration and visa consulting services,
                including visa application assistance, document preparation
            </p>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Comprehensive Visa Assistance</span>
            </div>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Visa Category Expertise</span>
            </div>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Transparency and Communication</span>
            </div>
        </div>
    )
}

export const VisaService = ({opened}) => {
    return (
        <div className={classNames("service-list",{"openlist": opened})}>
            <p className='faq-p'>
                We offer comprehensive immigration and visa consulting services,
                including visa application assistance, document preparation
            </p>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Comprehensive Visa Assistance</span>
            </div>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Visa Category Expertise</span>
            </div>
            <div className='pt-unit'>
                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                <span className='pt-unit'>Transparency and Communication</span>
            </div>
        </div>
    )
}